module.exports = __webpack_public_path__ + "static/media/laxmi.0a3c2b11.jpeg";